import { render } from "./imagenfinal2.vue?vue&type=template&id=66df6e04&scoped=true"
import script from "./imagenfinal2.vue?vue&type=script&lang=js"
export * from "./imagenfinal2.vue?vue&type=script&lang=js"

import "./imagenfinal2.vue?vue&type=style&index=0&id=66df6e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66df6e04"]])

export default __exports__